<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useI18n } from '@/composables/useI18n'

const { t } = useI18n()
const show = ref(false)

onMounted(() => {
  if (!localStorage.getItem('bimdrop-cookies-accepted')) {
    show.value = true
  }
})

function accept() {
  localStorage.setItem('bimdrop-cookies-accepted', 'true')
  show.value = false
}
</script>

<template>
  <Transition name="slide">
    <div v-if="show" class="cookie-banner">
      <div class="cookie-inner">
        <p>
          {{ t('cookies.message') }}
          <router-link to="/legal">{{ t('cookies.cookiePolicy') }}</router-link>.
        </p>
        <button class="ui-btn ui-btn-primary ui-btn-sm" @click="accept">{{ t('cookies.accept') }}</button>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.cookie-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 150;
  background: var(--nav-bg);
  backdrop-filter: blur(16px) saturate(140%);
  -webkit-backdrop-filter: blur(16px) saturate(140%);
  border-top: 1px solid var(--border);
  box-shadow: var(--shadow-lg);
  padding: 1rem 1.5rem;
}

.cookie-inner {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
}

.cookie-inner p {
  margin: 0;
  color: var(--text-muted);
  font-size: 0.85rem;
  line-height: 1.5;
}

.cookie-inner a {
  color: var(--accent-text);
  text-decoration: none;
  transition: color 0.2s var(--ease);
}

.cookie-inner a:hover {
  color: var(--accent);
  text-decoration: underline;
}

.slide-enter-active,
.slide-leave-active {
  transition: transform 0.3s var(--ease);
}

.slide-enter-from,
.slide-leave-to {
  transform: translateY(100%);
}
</style>
